import { useState, useEffect } from "react";
import AxiosInstance from "../Axios";
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import AddItemGallery from "./AddItemGallery";
import BasicModal from 'src/components/Modal';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from "../myComponents/MyToactify";
import { CButton } from "@coreui/react";
import { cilX, cilPencil } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { resolveSlide } from "../store/resolveSlide";

const GalleryList = ({ gallery_id, gallery, updateLists, setUpdateLists, updateGalleryObjects }) => {
 
  const urlApi_1 = "/gallery_items";
  const popup = MyToastify();

  const [galleryList, setGalleryList] = useState([]);
  const [selectedData, setSelectedData] = useState(null); // Вибрана галерея для редагування
  const [showModalItemUpdate, setShowModalItemUpdate] = useState(false); // Показати модальне вікно для оновлення галереї

  // Функція для відкривання модального вікна та оновлення даних
  const actionShowModalItemUpdate = (rez) => {
    setShowModalItemUpdate(rez);
    if (!rez) {
      setSelectedData(rez);
      setUpdateLists(true);
    };
  };

  // Функція для запиту за даними галереї
  const getGalleryItems = async () => {
    try {
      const response = await AxiosInstance.get(urlApi_1, { params: { gallery: gallery_id } });
      // console.log('gallery_items get response', response);
      // оновити вкладку галерея в об'єктах якщо зайшли з обєктів
      if(updateGalleryObjects !== undefined) {
        updateGalleryObjects(gallery_id);
      }
      setGalleryList(response.data['hydra:member']);
    } catch (error) {
      console.error("Помилка запиту за даними галереї", error);
    } finally {
      setUpdateLists(false);
    };
  };


  // видалити елемент галереї
  function removeGalleryItem (val) {
    try {
      AxiosInstance.delete(`${urlApi_1}/${val.id}`).then(() => {
        setUpdateLists(true);
        popup.toastifySuccess("Елемент галереї видалено");
      }).then(()=>{
        if(val?.media?.id) {
          AxiosInstance.delete(`/media_objects/${val?.media?.id}`).catch(()=>{
            popup.toastifyWarning("Помилка видалення media з апі");
          })
        }
      })
    } catch (error) {
      console.error("Помилка видалення за даними галереї", error);
    }
  }

  // Оновити галерею
  useEffect(() => {
    if (gallery_id && updateLists) {
      getGalleryItems();
    };
  }, [gallery_id, updateLists])

  // Відкривати вибрану галерею для редагування
  useEffect(() => {
    if (selectedData) {
      setShowModalItemUpdate(true);
    };
  }, [selectedData]);

  return (
    <>
      <div className="row row-cols-2 row-cols-md-3 g-3">
          {galleryList.map((val) => {
            const resolved = resolveSlide(val);
            return (
              <div className="col" key={val.id}>
                <div
                  className="position-relative"
                  style={{
                    width: '100%',
                    aspectRatio: '4 / 3',
                    border: '1px solid #e5e5e5',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    cursor: 'pointer'
                  }}
                  onClick={() => setSelectedData(val)}
                >
                  {resolved.type === "image" && <Card.Img src={resolved.src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                  {resolved.type === "iframe" && <iframe src={resolved.src} style={{ width: '100%', height: '100%' }}/>}
                  {resolved.type === "video" && <video src={resolved.src} style={{ width: '100%', height: '100%' }}></video>}
                  <CButton
                    color="light"
                    variant="outline"
                    size="sm"
                    className="delete-gallery-icon"
                    onClick={(e) => { e.stopPropagation(); removeGalleryItem(val); }}
                    title="Видалити"
                  >
                    <CIcon icon={cilX} customClassName="nav-icon" height={14} />
                  </CButton>
                  <CButton
                    color="light"
                    variant="outline"
                    size="sm"
                    className="edit-gallery-icon"
                    onClick={(e) => { e.stopPropagation(); setSelectedData(val); }}
                    title="Редагувати"
                  >
                    <CIcon icon={cilPencil} customClassName="nav-icon" height={14} />
                  </CButton>
                </div>
              </div>
            )
          })}
        </div>

      {/* Модальне вікно з вибраною галереєю */}
      {
        (selectedData && showModalItemUpdate) &&
        <div style={{ display: 'none' }}> {/* приховати кнопку відкритого модуля */}
          <BasicModal
            show={showModalItemUpdate}
            actionShowModal={actionShowModalItemUpdate}
            title={""}
            btn_name={<>🖊 редагувати</>}
            content={
              <AddItemGallery toastifySuccess={popup.toastifySuccess} parent_id={gallery_id} data={selectedData} actionShowModal={actionShowModalItemUpdate} gallery={gallery}/>
            }
          />
        </div>
      }
    </>
  );
};

export default GalleryList;